import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {SYSTEM_FULL_NAME, SYSTEM_NAME} from '../../../+app-custom/app.settings';

@Component({
    selector: 'app-sa-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    systemName = '';

    systemFullName = SYSTEM_FULL_NAME;


    constructor(private router: Router) {
        this.systemName = SYSTEM_NAME;
    }

    ngOnInit() {
    }

    navigateToHome() {
        this.router.navigate(['/dashboard']);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/layout/header/header.component.ts